module.exports = __webpack_public_path__ + "img/img(12).b443387f.png";